<div [formGroup]="form">
  <input type="text"
         [id]="field.controlName"
         [name]="field.controlName"
         [formControlName]="field.controlName"
         [placeholder]="field.placeholderText" class="m-0"/>
</div>
